import ReferrerTableActions from "../../components/settings/referrer/referrerTableActions";

interface ReferrerCardProps {
  data: {
    id: number;
    name: string;
    lead_source: string;
    mobile_no: string;
    email: string;
    created_by: string;
    created_at: string;
  };
  onClick: () => void;
  refetch: () => void;
}

const ReferrerCard = ({ data, onClick, refetch }: ReferrerCardProps) => {
  return (
    <div
      onClick={onClick}
      className="bg-white border border-gray-200 rounded-lg p-4 shadow-sm hover:shadow-md transition-shadow cursor-pointer"
    >
      {/* Header: ID, Name and Action Button */}
      <div className="flex justify-between items-start mb-3">
        <div className="flex-1">
          <span className="text-xs text-gray-500">#{data.id}</span>
          <h3 className="font-bold text-base text-gray-900 mt-1">{data.name}</h3>
        </div>
        {/* Action Button */}
        <div onClick={(e) => e.stopPropagation()}>
          <ReferrerTableActions
            id={data.id}
            name={data.name}
            lead_source={data.lead_source}
            mobile_no={data.mobile_no}
            email={data.email}
            refetch={refetch}
          />
        </div>
      </div>

      {/* Details Grid */}
      <div className="space-y-2 text-sm">
        {data.lead_source && (
          <div className="flex justify-between">
            <span className="text-gray-600">Lead Source:</span>
            <span className="font-medium text-gray-900">{data.lead_source}</span>
          </div>
        )}
        {data.mobile_no && (
          <div className="flex justify-between">
            <span className="text-gray-600">Phone Number:</span>
            <span className="font-medium text-gray-900">{data.mobile_no}</span>
          </div>
        )}
        {data.email && (
          <div className="flex justify-between">
            <span className="text-gray-600">Email:</span>
            <span className="font-medium text-gray-900">{data.email}</span>
          </div>
        )}
        {data.created_by && (
          <div className="flex justify-between">
            <span className="text-gray-600">Created By:</span>
            <span className="font-medium text-gray-900">{data.created_by}</span>
          </div>
        )}
        {data.created_at && (
          <div className="flex justify-between">
            <span className="text-gray-600">Created At:</span>
            <span className="font-medium text-gray-900">{data.created_at}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default ReferrerCard;